'use client';

import Image from 'next/image';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import unavailableScheduleClockSvg from '@/assets/schedules/unavailable-schedule-clock.svg?url';
import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';
import { Sheet, SheetClose, SheetContent, SheetHeader } from '@/components/ui/sheet';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

const TITLE = 'Horário indisponível';
const DESCRIPTION = 'Esse horário não está mais disponível! Por favor selecione um novo horário.';

interface UnavailableScheduleModalProps {
  open: boolean;
  onClose: () => void;
}

export function UnavailableScheduleModal({ open, onClose }: UnavailableScheduleModalProps) {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      onClose();
    }
  };

  return (
    <Sheet open={open} onOpenChange={handleOpenChange}>
      <SheetContent
        data-testid={DataTestIdEnum.UNAVAILABLE_SCHEDULE_MODAL}
        side="centerFit"
        hasHeader
        title={TITLE}
        description={DESCRIPTION}
        className="p-0 md:bg-transparent border-none overflow-x-hidden"
      >
        <SheetHeader className="bg-white">
          <div className="flex justify-end p-6 pb-0">
            <SheetClose
              data-testid={DataTestIdEnum.UNAVAILABLE_SCHEDULE_MODAL_CLOSE}
              asChild
              className="text-gray-500 cursor-pointer px-2 hover:bg-gray-50"
            >
              <button type="button" aria-label="Fechar">
                <Icon icon={faTimes} size="xl" className="text-[1.625rem] hover:text-gray-900" />
              </button>
            </SheetClose>
          </div>
        </SheetHeader>

        <div className="flex flex-col bg-white px-6 pb-6 pt-2">
          <Image
            src={unavailableScheduleClockSvg}
            alt=""
            width={200}
            height={200}
            draggable={false}
            className="self-center"
          />

          <Typography
            variant={TypographyVariant.MODAL_TITLE}
            className="mt-6"
            data-testid={DataTestIdEnum.UNAVAILABLE_SCHEDULE_MODAL_TITLE}
          >
            {TITLE}
          </Typography>

          <Typography
            className="mt-3 text-gray-700"
            data-testid={DataTestIdEnum.UNAVAILABLE_SCHEDULE_MODAL_DESCRIPTION}
          >
            {DESCRIPTION}
          </Typography>

          <Button
            className="mt-7"
            data-testid={DataTestIdEnum.UNAVAILABLE_SCHEDULE_MODAL_CONFIRM_BUTTON}
            onClick={onClose}
          >
            Entendi
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
